import { createAction, props } from '@ngrx/store';
import { IOdbBillCoverResponse } from '@dch/billing-business-logic';

export const GET_BILLING_COVER_REQUEST = 'GET_BILLING_COVER_REQUEST';
export const GET_BILLING_COVER_SUCCESS = 'GET_BILLING_COVER_SUCCESS';
export const GET_BILLING_COVER_FAILURE = 'GET_BILLING_COVER_FAILURE';

export const getBillingCoverRequest = createAction(
  GET_BILLING_COVER_REQUEST,
  props<{
    billingAccountNumber: string;
    reference: string;
  }>()
);

export const getBillingCoverSuccess = createAction(
  GET_BILLING_COVER_SUCCESS,
  props<{
    billingAccountNumber: string;
    reference: string;
    data: IOdbBillCoverResponse;
  }>()
);

export const getBillingCoverFailure = createAction(
  GET_BILLING_COVER_FAILURE,
  props<{ billingAccountNumber: string; reference: string }>()
);
